<template>
  <div class="p-max-wrap">
    <div class="p-max-1500">
      <swiper ref="mySwiper"
        :options="swiperOption">
        <swiper-slide v-for="item in items"
          :key="item.ID">
          <div class="conent-wrap"
            @click="gotoJob(item.ID)">
            <div class="article">
              <div class="title">
                <span class="big ft-25">{{ item.PRONAME }}</span>
                <span class="small ft-16">({{ item.MS }})</span>
              </div>
              <div class="line"></div>
              <div class="desc ft-14" v-html="item.MEMO"></div>
              <div class="line"></div>
            </div>

            <div class="btn-wrap">
              <div class="btn-know ft-16">{{$t('btn4')}}</div>
            </div>
          </div>
        </swiper-slide>
      </swiper>

      <div class="swiper-button-prev swiper-button-black"
        slot="button-prev"></div>
      <div class="swiper-button-next swiper-button-black"
        slot="button-next"></div>
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { getJobsUrl } from '@/util/url.js'
import axios from 'axios'

export default {
  components: {
    swiper,
    swiperSlide
  },

  data () {
    return {
      swiperOption: {
        // Basic 一般选项
        speed: 1600,
        // Loop 环路
        // loop: true,
        /* 组件 */
        // Autoplay 自动切换
        // autoplay: {
        //   // 用户操作swiper之后，是否禁止autoplay
        //   disableOnInteraction: false
        // },
        // 如果需要前进后退按钮
        // grid
        // centeredSlides: true,
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 2,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          768: {
            slidesPerView: 1
          }
        }
        // pagination: {
        //   el: '.swiper-pagination',
        //   type: 'fraction'
        // }
      },
      items: [
        // {
        //   ID: '0',
        //   title: '网店美工',
        //   sub: '电商部',
        //   desc: '<div>2008年汶川大地震，我们向灾区捐款捐物共计217万元。2010年玉树地震，我们向灾区捐款捐物共计50多万元。累计向市残联助残活动捐赠善款30万元。<br>招收残疾员工200多人，被市政府授予“残疾人就业基地”的荣誉称号。<br>与国家重点院校签订定向班，每年向200余大学生提供“阳光学子”就业培训，多年来共解决千余人的就业问题。为行业输送制造、设计、营销、物流仓储、管理等高端人才200多人。<div>'
        // },
        // {
        //   ID: '1',
        //   title: '网店美工',
        //   sub: '电商部',
        //   desc: '<div>2008年汶川大地震，我们向灾区捐款捐物共计217万元。2010年玉树地震，我们向灾区捐款捐物共计50多万元。累计向市残联助残活动捐赠善款30万元。<br>招收残疾员工200多人，被市政府授予“残疾人就业基地”的荣誉称号。<br>与国家重点院校签订定向班，每年向200余大学生提供“阳光学子”就业培训，多年来共解决千余人的就业问题。为行业输送制造、设计、营销、物流仓储、管理等高端人才200多人。<div>'
        // },
        // {
        //   ID: '2',
        //   title: '网店美工',
        //   sub: '电商部',
        //   desc: '<div>2008年汶川大地震，我们向灾区捐款捐物共计217万元。2010年玉树地震，我们向灾区捐款捐物共计50多万元。累计向市残联助残活动捐赠善款30万元。<br>招收残疾员工200多人，被市政府授予“残疾人就业基地”的荣誉称号。<br>与国家重点院校签订定向班，每年向200余大学生提供“阳光学子”就业培训，多年来共解决千余人的就业问题。为行业输送制造、设计、营销、物流仓储、管理等高端人才200多人。<div>'
        // },
        // {
        //   ID: '3',
        //   title: '网店美工',
        //   sub: '电商部',
        //   desc: '<div>2008年汶川大地震，我们向灾区捐款捐物共计217万元。2010年玉树地震，我们向灾区捐款捐物共计50多万元。累计向市残联助残活动捐赠善款30万元。<br>招收残疾员工200多人，被市政府授予“残疾人就业基地”的荣誉称号。<br>与国家重点院校签订定向班，每年向200余大学生提供“阳光学子”就业培训，多年来共解决千余人的就业问题。为行业输送制造、设计、营销、物流仓储、管理等高端人才200多人。<div>'
        // },
        // {
        //   ID: '4',
        //   title: '网店美工',
        //   sub: '电商部',
        //   desc: '<div>2008年汶川大地震，我们向灾区捐款捐物共计217万元。2010年玉树地震，我们向灾区捐款捐物共计50多万元。累计向市残联助残活动捐赠善款30万元。<br>招收残疾员工200多人，被市政府授予“残疾人就业基地”的荣誉称号。<br>与国家重点院校签订定向班，每年向200余大学生提供“阳光学子”就业培训，多年来共解决千余人的就业问题。为行业输送制造、设计、营销、物流仓储、管理等高端人才200多人。<div>'
        // },
        // {
        //   ID: '5',
        //   title: '网店美工',
        //   sub: '电商部',
        //   desc: '<div>2008年汶川大地震，我们向灾区捐款捐物共计217万元。2010年玉树地震，我们向灾区捐款捐物共计50多万元。累计向市残联助残活动捐赠善款30万元。<br>招收残疾员工200多人，被市政府授予“残疾人就业基地”的荣誉称号。<br>与国家重点院校签订定向班，每年向200余大学生提供“阳光学子”就业培训，多年来共解决千余人的就业问题。为行业输送制造、设计、营销、物流仓储、管理等高端人才200多人。<div>'
        // }
      ]
    }
  },

  mounted () {
    this.fechData()
  },

  methods: {
    fechData () {
      const url = getJobsUrl(this.$store.state.lang)
      axios.get(url).then(res => {
        // console.log(res)
        if (res && res.data && res.data.proarr && res.data.proarr.length > 0) {
          this.items = res.data.proarr
        }
      })
    },

    gotoJob (id) {
      this.$router.push(`/job/${id}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.p-max-1500 {
  margin: 0 80px;
  position: relative;
}

.btn-wrap {
  margin-top: 24px;
}

.conent-wrap {
  cursor: pointer;
  padding: 30px;
  color: #03192f;
  background-color: #cfe8f8;
  transition: background-color 1.6s cubic-bezier(.77,.15,0,.99),
    color 1.6s cubic-bezier(.77,.15,0,.99);

  .btn-know {
    // cursor: pointer;
    width: 166px;
    height: 64px;
    border-width: 1px;
    border-style: solid;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #03192f;
    border-color: #03192f;
    background-color: #cfe8f8;
  }

  .article {
    padding-top: 68px;
    width: 100%;
    max-width: 800px;
    margin: 0 auto;

    .title {
      // text-align: center;
      // color: #03192f;
      line-height: 50px;
      margin-bottom: 24px;

      span {
        display: inline-block;
        margin-right: 16px;
      }
    }

    .line {
      height: 1px;
      background-color: #cfe8f8;
    }

    .desc {
      // color: #3c546e;
      line-height: 40px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 8;
      overflow: hidden;
      height:350px;
    }
  }
}

.conent-wrap:hover {
  color: #cfe8f8;
  background-color: #03192f;
}

.swiper-button-prev {
  transform: translateX(-60px)
}
.swiper-button-next {
  transform: translateX(60px)
}
@media(max-width: 768px){
  .p-max-1500{
    margin: 0 30px;
  }
}
</style>
